import { useQuery } from '@tanstack/react-query';
import { IMergeTags } from '@opengov/stories-shared/types';

import { postJson } from '../../../../utils/fetchUtils';
import { useToast } from '../../../Toast/context/useToast.context';

import { publicationCustomCssQueryKeys } from './publicationCustomCssQueryKeys';

type ProposalsResponse = {
  mergeTags: IMergeTags;
};

export type UseStoryProposalsParams = {
  storyId: string;
  entityId: number;
} | null;

export function useStoryProposals(
  params: UseStoryProposalsParams,
  errorMessage: string
) {
  const { toggleToast } = useToast();

  return useQuery<ProposalsResponse>({
    queryKey: params
      ? ([...publicationCustomCssQueryKeys.all, 'storyProposals', params] as const)
      : ([...publicationCustomCssQueryKeys.all, 'storyProposals', 'disabled'] as const),
    queryFn: () =>
      postJson<ProposalsResponse>(`/api/stories/v1/stories/getProposalsInStory`, {
        story_id: params!.storyId,
        entity_id: params!.entityId
      }),
    enabled: params !== null,
    onError: () => {
      toggleToast({ title: errorMessage, severity: 'error' });
    }
  });
}
